exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-block {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n}\r\n.ic-block__header {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-flow: row nowrap;\r\n        flex-flow: row nowrap;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    padding: 8px;\r\n}\r\n.ic-block__title {\r\n    -ms-flex: 0 0 auto;\r\n        flex: 0 0 auto;\r\n    font-size: 18px;\r\n    color: #526069;\r\n    font-weight: 300;\r\n}\r\n.ic-block__line {\r\n    -ms-flex: 1 1 auto;\r\n        flex: 1 1 auto;\r\n    height: 1px;\r\n    background: rgba(0, 0, 0, .24);\r\n    margin-left: 8px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/block/block.component.css
// module id = ../../../../../src/app/layout/block/block.component.css
// module chunks = main